import { cn } from '@/lib/utils/cn';

interface SwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  id?: string;
  /** Ayuda al pasar el mouse (y descripción para el lector de pantalla). */
  title?: string;
  /** El nombre para un lector de pantalla cuando no hay un <label> al lado. */
  'aria-label'?: string;
  /** O el id del texto que lo nombra (el título de la fila). */
  'aria-labelledby'?: string;
  /** `lg`: el de las maquetas de Mi empresa (débito automático, reglas de aprobación). */
  tamano?: 'md' | 'lg';
}

export function Switch({
  checked,
  onCheckedChange,
  disabled,
  className,
  id,
  title,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledby,
  tamano = 'md',
}: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      data-ui="switch"
      data-tamano={tamano}
      id={id}
      title={title}
      aria-checked={checked}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledby}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={cn(
        // Dentro de Compite las medidas van en px (ver `[data-ui='switch']` en index.css).
        'inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors',
        tamano === 'lg' ? 'h-7 w-12' : 'h-5 w-9',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        // Encendido, con el degradado de la marca (capturas de Melanie, 25-oct).
        checked ? 'bg-primary bg-degradado-prixia' : 'bg-input',
        className
      )}
    >
      <span
        data-ui="switch-bola"
        className={cn(
          'pointer-events-none block rounded-full bg-campo shadow-lg ring-0 transition-transform',
          tamano === 'lg' ? 'size-6' : 'h-4 w-4',
          checked ? (tamano === 'lg' ? 'translate-x-5' : 'translate-x-4') : 'translate-x-0'
        )}
      />
    </button>
  );
}
